import { TriangleAlert } from 'lucide-react';

import { pluralize } from '@nesso/ui/lib/utils';
import { Alert, AlertDescription, AlertTitle } from '@nesso/ui/primitives/alert';

type Props = {
    retryAfterSeconds: number;
};

export function SignInWithPasswordCooldownAlert({ retryAfterSeconds }: Props) {
    const minutes = Math.ceil(retryAfterSeconds / 60);

    return (
        <Alert variant="warning">
            <TriangleAlert />
            <AlertTitle>Too many failed attempts</AlertTitle>
            <AlertDescription className="[&_p]:leading-6">
                <p>Wait {pluralize(minutes, 'minute')} before trying again</p>
            </AlertDescription>
        </Alert>
    );
}
